export default {
    url_prefix: 'p/onboard',
    webFormPrefix: 'p/pm-intake'
};
